import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";
import styles from "./DatePicker.module.css";
import CalendarIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/CalendarIconPath";
import { FixaFormField } from "@coworker/apprestructured/src/shared/wrappers/FixaFormField/FixaFormField";
import { i18n } from "@coworker/locales";
import { useRef } from "react";
import { getDateFormatsForLocale } from "./helper";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

type DatePickerProps = {
  label?: string | undefined;
  value: string;
  onChange: (value: string) => void;
  errorMessage?: string | null;
  min?: string | undefined;
  max?: string | undefined;
};

export const DatePicker = ({
  label,
  value,
  onChange,
  errorMessage,
  min,
  max,
}: DatePickerProps) => {
  const nativeInputRef = useRef<HTMLInputElement>(null);

  const handleOnClick = (e?: React.MouseEvent) => {
    e?.preventDefault();
    e?.stopPropagation();

    const input = nativeInputRef.current;
    if (!input) return;

    input.focus();
    input.showPicker();
  };

  const locale = i18n.language;
  const dateFormatsForLocale = getDateFormatsForLocale(locale);
  const inputFieldValue = value
    ? dayjs(value, "YYYY-MM-DD", true).format(dateFormatsForLocale.full)
    : dateFormatsForLocale.full;

  return (
    <div className={styles["root"]}>
      <input
        ref={nativeInputRef}
        type="date"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        tabIndex={-1}
        className={styles["nativeInput"]}
        min={min}
        max={max}
      />
      <FixaFormField
        valid={!errorMessage}
        shouldValidate={!!errorMessage}
        validation={{ id: "datePicker", msg: errorMessage, type: "error" }}
        className={styles["formField"]}
      >
        <FixaInputField
          id="dateInput"
          type="text"
          value={inputFieldValue}
          ssrIcon={CalendarIconPath}
          iconPosition="trailing"
          iconOnClick={handleOnClick}
          onClick={handleOnClick}
          label={label}
        />
      </FixaFormField>
    </div>
  );
};
